<div class="pay pay-err staps record">
    <div class="pay__top record-top">
        <div class="record-top__left">
            <div class="record-top__title record-title">Онлайн-оплата</div>
        </div>
        <button class="list-cloce reset" (click)="DialogRef.close(null)">
            <img
                src="./assets/icons/actions/close-modal.svg"
                alt="Закрыть"
                [mat-dialog-close]="true"
            />
        </button>
    </div>

    <div class="pay__center">
        <div class="pay__mail mail" *ngIf="emailRequiredForPay">
            <input
                id="mail"
                class="mail__input reset"
                placeholder="Адрес почты"
                type="email"
                [(ngModel)]="email"
            />
            <label for="mail" class="mail__label">
                Почта для получения чека
            </label>
        </div>
        <div class="pay__mail mail" *ngIf="phoneRequiredForPay">
            <input
                id="phone"
                class="mail__input reset"
                placeholder="+7 (999) 999-99-99"
                type="tel"
                phoneMask
                inputmode="numeric"
                [(ngModel)]="phone"
                autocomplete="tel"
                aria-label="Номер телефона"
            />
            <label for="phone" class="mail__label">Номер телефона</label>
        </div>
        <div class="pay__total total">
            <span class="total__label">Всего к оплате</span>
            <strong class="total__price">{{ sum }} рублей</strong>
        </div>
    </div>

    <div class="pay__nav">
        <div class="pay__row"></div>
        <div class="pay-err__bottom bottom-apply">
            <!-- Сообщение об ошибке ввода -->
            <div
                class="pay-error-message"
                *ngIf="getPayErrorMessage()"
                style="
                    color: #e53935;
                    font-size: 14px;
                    margin-bottom: 8px;
                    text-align: center;
                "
            >
                {{ getPayErrorMessage() }}
            </div>
            <!-- Кнопка оплатить -->
            <button
                class="bottom-apply__btn use reset"
                (click)="submitPayment()"
                [disabled]="validPay()"
                [title]="getPayErrorMessage() || null"
            >
                <svg
                    width="25"
                    height="17"
                    viewBox="0 0 25 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.94424 0H21.9782C23.0772 0 24.007 0.929851 24.007 1.94424V14.1167C24.007 15.2156 23.0772 16.0609 21.9782 16.0609H1.94424C0.929851 16.0609 0 15.2156 0 14.1167V1.94424C0 0.929851 0.929851 0 1.94424 0ZM2.02877 7.43867H22.4853V9.89011H2.02877V7.43867ZM2.53597 2.02857H7.35413C7.60772 2.02857 7.86132 2.28217 7.86132 2.53577V5.49443C7.86132 5.74803 7.60772 5.91709 7.35413 5.91709H2.53597C2.28237 5.91709 2.02877 5.74802 2.02877 5.49443V2.53577C2.02877 2.28217 2.28237 2.02857 2.53597 2.02857Z"
                        fill="white"
                    />
                </svg>
                Оплатить
            </button>
        </div>
    </div>
</div>
